<!--
무자료 등록(재고방식) > 상품추가 (리스트) > 상품추가
-->
<template>
    <!-- 폼 화면 -->
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-7-8">

            <div class="uk-modal-header">
                무자료 상품추가
            </div>

            <div class="uk-modal-body">

                <div class="uk-flex uk-flex-center">
                    <!-- 업로드 모듈 -->
                    <div class="col-upload">

                        <app-file-uploader
                            ref="upload"
                            class="uk-margin-right"
                            :csrf-token="csrfToken"
                            :type="99"
                            :session-owner="sessionOwner"
                            header-text="이미지 촬영"
                            size=""
                            header-button-is-primary
                            vertical-layout
                            @update:ids="val => fileIds = val"
                        ></app-file-uploader>

                        <div class="photo-desc">
                            * 이미지가 선명하고 사이즈가 보이도록 찍어주세요<br/>
                            * 트래킹라벨 이미지 꼭 찍어주세요
                        </div>
                    </div>


                    <!-- 상품정보 입력  -->
                    <div class="uk-width-expand">
                        <table class="input-table">
                            <tr>
                                <th class="highlight">
                                    <i class="material-icons">
                                        info
                                    </i>
                                    수량(QTY)
                                </th>
                                <td>
                                    <app-input-text
                                        class=""
                                        v-model="inputs.amount"

                                        placeholder="낱개수량"
                                    ></app-input-text>
                                </td>

                                <th class="highlight">
                                    <i class="material-icons">
                                        info
                                    </i>
                                    사이즈
                                </th>
                                <td>
                                    <app-input-text
                                        class=""
                                        v-model="inputs.size"
                                    ></app-input-text>
                                </td>
                            </tr>


                            <tr>
                                <th>
                                    <i class="material-icons">
                                        info
                                    </i>
                                    색상
                                </th>
                                <td colspan="3">
                                    <app-input-text
                                        class=""
                                        v-model="inputs.color"
                                    ></app-input-text>
                                </td>
                            </tr>

                            <tr>
                                <th>
                                    <i class="material-icons">
                                        info
                                    </i>
                                    상품명
                                </th>
                                <td colspan="3">
                                    <app-input-text
                                        class=""
                                        v-model="inputs.name"
                                    ></app-input-text>
                                    <div class="name-desc">
                                        하자발견시 하자내용을 상품명에 설명해주세요
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <i class="material-icons">
                                        receipt
                                    </i>
                                    해외주문번호
                                </th>
                                <td colspan="3">
                                    <app-input-text
                                        class=""
                                        v-model="inputs.buy_order_code"
                                    ></app-input-text>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <i class="material-icons">
                                        comment
                                    </i>
                                    관리메모
                                </th>
                                <td colspan="3">
                                    <app-input-textarea
                                        class=""
                                        v-model="inputs.memo"
                                        :textarea-rows="1"
                                    ></app-input-textarea>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <i class="material-icons">
                                        comment
                                    </i>
                                    유통기한
                                </th>
                                <td colspan="3">
                                    <app-input-text
                                        class=""
                                        v-model="inputs.expiration_date"
                                        placeholder="날짜입력"
                                    ></app-input-text>
                                    <div class="name-desc">
                                        건강식품/식품, 동물영양제인 경우만 입력해 주세요
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>

                </div>


            </div>


            <div class="uk-modal-footer uk-text-right">

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-large uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-large uk-button-primary"
                    @click="submit"
                >
                    <span uk-icon="icon: check"></span>
                    저장
                </button>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        // csrf-token
        csrfToken: String,

        // 지역ID
        regionId: Number,

        /**
         * 지역코드
         * (미국 커스텀때문에 추가됨)
         * 1 : 일본
         * 2 : 미국
         * 3 : 중국항공
         * 4 : 중국해상
         * 5 : 영국
         * 6 : 독일
         * 7 : 호주
         **/
        regionCode: {
            type: Number,
            default: null,
        },

        // 첨부파일용 로그인(세션)ID
        sessionOwner: Number,

        /**
         * 상품 수 (품목)
         */
        prodCount: {
            type: Number,
        },

    },
    data: function () {
        return {
            // (object) 박스정보
            box: {},

            // (object) 입력
            inputs: {},

            // (Array) 업로드 파일ID 배열
            fileIds: [],


            /**
             * (boolean)
             * 보관장소 자동발급 여부
             */
            autoStorage: false,


        };
    },
    computed: {},
    methods: {
        /**
         * 입력폼 display
         */
        displayForm() {

            UIkit.modal(this.$el).show();
        },

        /**
         * 폼
         * @param box (object) 박스정보
         */
        form(box) {
            this.box = box;
            this.fileIds = [];

            this.inputs = {
                amount: null,
                size: null,
                color: null,
                name: null,
                buy_order_code: null,
                memo: null,
                expiration_date: null,
            };

            // 보관장소 자동발급 여부
            this.autoStorage = this.prodCount === 0;

            // 업로드모듈 초기화
            this.$refs.upload.init();

            // 폼 디스플레이
            this.displayForm();
        },

        /**
         * submit
         */
        submit() {
            // 수량검증
            if (!this.inputs.amount) {
                alert('수량을 반드시 입력하세요');
                return;
            }

            // promise 생성
            let p = new Promise((resolve, reject) => {
                // 상품명 결정
                let name = this.box.name_prefix;
                if (this.inputs.name) {
                    name += ' ' + this.inputs.name;
                }

                // 전송필드
                let data = {
                    '_token': this.csrfToken,
                    'file_ids': JSON.stringify(this.fileIds),

                    user_id: this.box.user_id,
                    tracking_no: this.box.tracking_no,

                    amount: this.inputs.amount,
                    size: this.inputs.size,
                    color: this.inputs.color,
                    name: name,
                    buy_order_code: this.inputs.buy_order_code,
                    memo: this.inputs.memo,
                    expiration_date: this.inputs.expiration_date,

                    auto_storage: this.autoStorage,
                    storage: this.box.storage,
                    use_prod_id_storage: false,

                };

                // 미국은 상품번호를 보관장소로 사용
                if (this.regionCode === 2) {
                    data.auto_storage = false;
                    data.storage = null;
                    data.use_prod_id_storage = true;
                }

                // ajax 옵션
                let opts = {
                    type: 'post',
                    url: '/regions/' + this.regionId + '/nodata-stocks',
                    data: data,
                    success: (response, textStatus, jqXHR) => {
                        // promise 성공
                        resolve(response);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        reject();
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            });


            // promise 처리
            p.then((response) => {
                this.$emit('added', response.prod);
                UIkit.modal(this.$el).hide();
            }).catch(() => {
                // 오류인경우
            });
        },


    },


}
</script>


<style lang="scss" scoped>
.uk-modal-header {
    font-size: 1.25rem;
    font-weight: bold;
}

.col-upload {
    width: 40%;
}

// 테이블
.input-table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;

    th, td {
        text-align: left;
        border: 1px solid #cfcfcf;
        font-weight: normal;

        padding: 0.5rem;
        color: #000;
    }

    th {

        font-size: 1rem;
        background-color: #fefefe;
        width: 10rem;

        .material-icons {
            vertical-align: middle;
            font-size: 1.5rem;
            color: #aaa;
        }

        &.highlight .material-icons {
            color: #1e87f0 !important;
        }

    }

    td {
        text-align: center;
        font-size: 1.25rem;
        color: #000;
        //width: 25rem;

        &.highlight {
            //background-color: #ffffdd;
        }
    }

}

// 이미지 촬영 안내문
.photo-desc {
    padding: 10px;
    border: 1px solid #000;
    background-color: #ffffdd;
    color: #000;
    margin-right: 10px;
    margin-bottom: 0.5rem;
    font-size: 1rem;
}

// 상품명 작성 안내문
.name-desc {
    margin: 10px 0;
    padding: 10px;
    border: 1px solid #000;
    background-color: #ffffdd;
    color: #000;
    font-size: 1rem;
    text-align: left;
}
</style>